import LockIcon from "@components/common/icons/lock.icon";
import { Box, Typography } from "@mui/material";

type Props = {
  startCode: string | undefined;
  destinationCode: string | undefined;
};

function ConfirmedCreatedDeliveryCodes({ startCode, destinationCode }: Props) {
  const codeError = (
    <Typography component="i" sx={{ fontSize: "var(--medium-font-size)", fontWeight: "bold" }}>
      Erreur lors de la récupération du code
    </Typography>
  );

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
        mb: "2rem",
      }}
    >
      {[
        { label: "Code de sécurité de début de réception", value: startCode },
        { label: "Code de sécurité de fin de réception", value: destinationCode },
      ].map(({ label, value }, index) => (
        <Box
          key={index}
          className="item"
          sx={{
            padding: "1rem",
            flex: 1,
            minWidth: "250px",
            borderRadius: 2,
            boxShadow: 1,
            backgroundColor: "#fff",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mb: "1rem",
            }}
          >
            <LockIcon />
            <Typography component="span" sx={{ ml: 1 }}>
              {label}
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: "var(--large-font-size)",
              fontWeight: 400,
            }}
          >
            {value ?? codeError}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default ConfirmedCreatedDeliveryCodes;
